import { getUserLists } from './actions'

export const fetchLists = async (searchTerm = '') => {
  const { lists } = await getUserLists()
  const trimmedSearchTerm = searchTerm.trim().toLowerCase()

  if (trimmedSearchTerm !== '') {
    const items = lists.filter((list) =>
      list.label.toLowerCase().includes(trimmedSearchTerm)
    )
    return { items, totalItems: items.length }
  }

  return { items: lists, totalItems: lists.length }
}
